import { ResultStatuses } from '../constants';

const RESULT_COLUMNS = [
  // request
  { id: 'internalMemberId', displayName: 'Member ID' },
  { id: 'memberId', displayName: 'HP ID' },
  { id: 'firstName', displayName: 'First Name' },
  { id: 'lastName', displayName: 'Last Name' },
  { id: 'dateOfBirth', displayName: 'DOB' },
  { id: 'skuCode', displayName: 'SKU' },
  { id: 'consultCost', displayName: 'Total Cost' },

  // response
  { id: 'teladocGroupId', displayName: 'TD Group ID' },
  { id: 'groupId', displayName: 'Ext Group ID' },
  { id: 'ref18', displayName: 'Plan Code'},
  { id: 'rejectCode', displayName: 'Error Code' },
  { id: 'copay', displayName: 'Copay' },
  { id: 'coinsurancePercent', displayName: 'Coinsurance %' },
  { id: 'deductible', displayName: 'Deductible' },
  { id: 'oop', displayName: 'OOP' },
  { id: 'hra', displayName: 'HRA' },
  { id: 'responsibility', displayName: 'Member Cost' }
];

function initialTestResults(members, options) {
  const { payerId, skuCodes, consultCost: consultCostMap } = options;
  const results = [];

  for (const member of members) {
    let memberAttrs;
    if (Array.isArray(member)) {
      // csv member
      const [memberId, firstName, lastName, dateOfBirth, sourceGroupID, groupMoverFlg] = member;
      memberAttrs = { memberId, firstName, lastName, dateOfBirth, sourceGroupID, groupMoverFlg };
    } else {
      // existing member
      memberAttrs = member;
    }

    for (const skuCode of skuCodes) {
      const consultCost = consultCostMap[skuCode];
      results.push({
        status: ResultStatuses.PENDING,
        index:  results.length,
        payerId,
        skuCode,
        consultCost,
        ...memberAttrs
      });
    }
  }
  return results;
}

function updateTestResults(results, newResult, status) {
  return results.map(result => {
    if (result.index !== newResult.index) {
      return result;
    }
    return {
      ...result,
      ...newResult,
      status
    };
  });
}

function cancelTestResults(results) {
  return results.map(result => {
    if (result.status === ResultStatuses.COMPLETE) {
      return result;
    }
    return {
      ...result,
      status: ResultStatuses.CANCELED
    };
  });
}

/**
 * Get the overall status of the testing process
 */
function testStatus(results) {
  if (!results) {
    return ResultStatuses.PENDING;
  }
  for (const result of results) {
    if (result.status === ResultStatuses.LOADING) {
      return ResultStatuses.LOADING;
    }
    if (result.status === ResultStatuses.CANCELED) {
      return ResultStatuses.CANCELED;
    }
    if (result.status === ResultStatuses.ERROR) {
      return ResultStatuses.ERROR;
    }
  }
  return ResultStatuses.COMPLETE;
}

export default {
  RESULT_COLUMNS,
  initialTestResults,
  updateTestResults,
  cancelTestResults,
  testStatus
};
